import Box from "@mui/material/Box";
import * as React from "react";
import GridContext from "../context/GridContext";
import EditSide from "./grid/components/EditSide";
import MainGrid from "./grid/components/MainGrid";
import bottombarlayouts from "./grid/data/bottombarlayouts";

import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { motion } from "framer-motion";
import { useBlocker, useLocation } from "react-router-dom";
import { useMount } from "react-use";
import { API_ENDPOINTS } from "../API/apiConfig";
import { useAppContext } from "../appContext";
import { CursorContextProvider } from "../components/CursorContextProvider";
import Spinner from "../components/Spinner/Spinner";
import { DataGridContext } from "../context/DataGridContext";
import FunctionBarContext from "../context/FunctionBarContext";
import { useUserState } from "../context/UserContext";
import { checkPermissions } from "./AccessControl";
import { getTextColour } from "./datagrids/utils";
import DesignerToolbar from "./DesignerToolbar";
import AdvancedSettings from "./grid/components/AdvancedSettings";
import ErrorDialog from "./grid/components/ErrorDialog";
import ListDeleteDialog from "./grid/components/ListDeleteDialog";
import ListVariantForm from "./grid/components/ListVariantForm";
import NewItemModal from "./grid/components/NewItemModal";
import NewListModal from "./grid/components/NewListModal";
import NewPageDialog from "./grid/components/NewPageDialog";
import listAreas from "./grid/data/listAreas";
import addButtonId, {
  autoFill,
  getHistory,
  handleRevertChanges,
} from "./DesignerUtils";

export default function ListDesignerRefactor() {
  const item = useLocation();
  const { data, setData, loading, variant, setVariant } =
    React.useContext(DataGridContext);
  const userPermission = useUserState();
  const contextName = "screens";
  const {
    setState,
    state: { tourActive },
  } = useAppContext();

  useMount(() => {
    if (tourActive) {
      setTimeout(() => {
        setState({ run: true });
      }, 600);
    }
  });

  const { getAccessTokenSilently } = useAuth0();

  let initialBottomList = data[contextName]?.find(
    (list) => list?.list_details?.location === "F3" && list.list_isDeleted === 0
  );

  const [list, setList] = React.useState(
    structuredClone(
      item?.state !== null && item?.state?.item !== null
        ? item?.state?.item
        : data[contextName].filter(
            (list) =>
              list?.list_details?.location === "L2" &&
              list.list_isDeleted === 0 &&
              list.list_variant === 0
          )[0]
    )
  );

  const [variantOptions, setVariantOptions] = React.useState(
    data[contextName]?.filter(
      (screen) =>
        parseInt(screen.list_number) === parseInt(list.list_number) &&
        screen.list_isDeleted === 0
    )
  );
  // console.log(variantOptions);
  // const variantInit = data[contextName]?.find(
  //   (screen) =>
  //     screen.list_variant === 0 &&
  //     parseInt(screen.list_number) === parseInt(list.list_number) &&
  //     screen.list_isDeleted === 0
  // );

  const variantInit2 = React.useMemo(() => {
    if (!list) return 1;

    // prefer explicit property first, fall back to dynamic
    return data[contextName]?.find(
      (screen) =>
        screen.list_variant === 0 &&
        parseInt(screen.list_number) === parseInt(list.list_number) &&
        screen.list_isDeleted === 0
    );
  }, [list, contextName]);

  const [bottomBarItems, setBottomBarItems] = React.useState(
    initialBottomList?.list_details?.buttons
  );
  const [isSaving, setIsSaving] = React.useState(false);

  const sortItems = (a, b) => a.list_number - b.list_number;

  const [listOptions, setListOptions] = React.useState(
    data[contextName]
      .filter((list) =>
        // list?.list_details?.location !== "F3" &&
        // list?.list_details?.ignoreThisList !== true &&
        checkPermissions(userPermission, {
          page: "screens",
          action: "disableTillSending",
          api: "GSAdmin",
          strict: true,
        }) === false
          ? list?.list_variant === 0 &&
            list?.list_isDeleted === 0 &&
            list?.list_details?.ignoreThisList !== true
          : list?.list_isDeleted === 0 && list?.list_variant === 0
      )
      .sort(sortItems)
  );

  const [page, setPage] = React.useState(1);

  const [advancedSettings, openAdvancedSettings] = React.useState(false);

  const [listArea, setListArea] = React.useState(
    listAreas.find((area) => area?.tillName === list?.list_details?.location)
  );
  const [newMain, setNewMain] = React.useState(
    variantOptions.filter((item) => item.list_variant !== 0)[0]
  );

  const [openItem, setItem] = React.useState({});
  const [newPage, setNewPage] = React.useState(false);

  const [editBar, openEditBar] = React.useState(false);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [newVariant, setNewVariant] = React.useState(false);
  const [newChanges, setNewChanges] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState({
    open: false,
    text: null,
    button1text: "",
    button1func: null,
    button2text: "",
    button2func: null,
  });
  const [deleteErrorMessage, setDeleteErrorMessage] = React.useState({
    open: false,
    text: null,
    button1text: "",
    button1func: null,
    button2text: "",
    button2func: null,
  });
  const [pageArr, setPageArr] = React.useState([]);

  const [bottomLayout, setBottomLayout] = React.useState(bottombarlayouts[0]);
  const [openDropDown, setOpenDropdown] = React.useState(false);
  const [listHistory, setListHistory] = React.useState([]);
  const [index, setIndex] = React.useState();

  let shouldBlock = React.useCallback(
    ({ currentLocation, nextLocation }) =>
      newChanges && currentLocation.pathname !== nextLocation.pathname,
    [newChanges]
  );
  let blocker = useBlocker(shouldBlock);

  // function addButtonId() {
  //   setVariant((draft) => {
  //     draft?.list_details?.buttons?.map((button, index) => {
  //       button.id = index.toString();
  //       button.index = index;
  //       return button;
  //     });
  //   });
  // }

  const handleNext = () => {
    setVariant(listHistory[index + 1]);
    addButtonId(setVariant);
    setIndex((index) => index + 1);
    setNewChanges(false);
    setPage(1);
  };

  const handlePrev = () => {
    setVariant(listHistory[index - 1]);
    addButtonId(setVariant);
    setIndex((index) => index - 1);
    setNewChanges(false);
    setPage(1);
  };

  React.useEffect(() => {
    setVariantOptions(
      data[contextName]?.filter(
        (screen) =>
          parseInt(screen.list_number) === parseInt(list.list_number) &&
          screen.list_isDeleted === 0
      )
    );
  }, [data]);

  // React.useEffect(() => {
  //   getHistory(variantInit2);
  // }, [setList, list, setVariant]);

  React.useEffect(() => {
    if (variantInit2) {
      getHistory(
        variantInit2,
        getAccessTokenSilently,
        setListHistory,
        setVariant,
        setPageArr,
        setItem,
        setIndex
      );
    }
  }, [variantInit2]);

  // React.useEffect(() => {
  //   if (!variantInit2) return;

  //   const abortController = new AbortController();

  //   getHistory(variantInit2, { signal: abortController.signal }).catch(
  //     (err) => {
  //       if (err.name !== "CanceledError") {
  //         console.error("Failed to fetch history", err);
  //       }
  //     }
  //   );

  //   return () => {
  //     abortController.abort();
  //   };
  // }, [variantInit2]);

  const handleCloseEditBar = () => openEditBar(false);

  // const handleRevertChanges = (type, newValue, data, contextName, variant, handleListSelect2, handleVariantSelect2, setList, setVariant, setPageArr,setPage,closeDialog,setNewChanges) => {
  //   const originalList = structuredClone(
  //     data[contextName].filter(
  //       (original) =>
  //         JSON.parse(original?.uid) === JSON.parse(variant?.uid) &&
  //         original.list_isDeleted === 0
  //     )[0]
  //   );

  //   if (type === "list change") {
  //     handleListSelect2("list change", newValue);
  //   } else if (type === "variant change") {
  //     handleVariantSelect2("variant change", newValue);
  //   } else {
  //     setList(originalList);
  //     setVariant(
  //       data[contextName].find(
  //         (screen) =>
  //           JSON.parse(screen.uid) === JSON.parse(originalList.uid) &&
  //           screen.list_isDeleted === 0
  //       )
  //     );
  //     setPageArr(
  //       Array.from(Array(originalList?.list_details?.pages), (e, i) => i + 1)
  //     );
  //     setPage(1);
  //   }
  //   closeDialog();
  //   setNewChanges(false);
  // };

  const handleListSelect = (event, newValue) => {
    if (newChanges === true) {
      setErrorMessage({
        open: true,
        text: `You have unfinished changes to list '${list.list_name}'. Please save or discard any changes before continuing.`,
        button1text: "Discard Changes",
        button1func: () =>
          handleRevertChanges(
            "list change",
            newValue,
            data,
            contextName,
            variant,
            handleListSelect2,
            handleVariantSelect2,
            setList,
            setVariant,
            setPageArr,
            setPage,
            closeDialog,
            setNewChanges
          ),
        button2text: "Save Changes",
        button2func: () => handleSubmitLayout("list change", newValue),
      });
      // setNewChanges(false);
    } else {
      handleListSelect2("null", newValue);
    }
  };

  const handleListSelect2 = (type, newValue) => {
    if (newValue !== null) {
      const updatedList = data?.screens?.find(
        (list) =>
          JSON.parse(list.uid) === JSON.parse(newValue.uid) &&
          list.list_isDeleted === 0
      );

      const newList = structuredClone(updatedList);
      setList(newList);

      const options = data?.screens?.filter(
        (screen) =>
          screen.list_number === newList.list_number &&
          screen.list_isDeleted === 0
      );
      setVariantOptions(options);
      if (newList?.list_details?.location === "F3") {
        setBottomBarItems(
          newList?.list_details?.buttons.filter(
            (button) => button?.pageNo === 1
          )
        );
        setBottomLayout({
          row: newList.list_details?.rows,
          col: newList.list_details?.cols,
          value: `${newList.list_details?.rows}x${newList.list_details?.cols}`,
        });
      }
      setPage(1);

      setListArea(
        listAreas.find(
          (area) => area?.tillName === newList?.list_details?.location
        )
      );
    }
  };

  const handleVariantSelect = (event, newValue) => {
    if (newChanges === true) {
      setErrorMessage({
        open: true,
        text: `You have unfinished changes to list '${variant.list_name}'. Please save or discard any changes before continuing.`,
        button1text: "Discard Changes",
        button1func: () =>
          handleRevertChanges(
            "variant change",
            event.target.value,
            data,
            contextName,
            variant,
            handleListSelect2,
            handleVariantSelect2,
            setList,
            setVariant,
            setPageArr,
            setPage,
            closeDialog,
            setNewChanges
          ),
        button2text: "Save Changes",
        button2func: () =>
          handleSubmitLayout("variant change", event.target.value),
      });
    } else {
      handleVariantSelect2("null", event.target.value);
    }
  };

  const handleVariantSelect2 = (type, value) => {
    if (value !== null) {
      const updatedList = data[contextName]?.find(
        (list) =>
          parseInt(list?.uid) === parseInt(value?.uid) ||
          (parseInt(list?.list_uid) === parseInt(value?.list_uid) &&
            list?.list_isDeleted === 0)
      );

      const newList = structuredClone(updatedList);
      if (newList?.list_details?.location === "F3") {
        setBottomBarItems(
          newList?.list_details?.buttons.filter(
            (button) => button?.pageNo === 1
          )
        );
        setBottomLayout({
          row: newList.list_details?.rows,
          col: newList.list_details?.cols,
          value: `${newList.list_details?.rows}x${newList.list_details?.cols}`,
        });
      }
      setListArea(
        listAreas.find(
          (area) => area?.tillName === newList?.list_details?.location
        )
      );
      getHistory(
        newList,
        getAccessTokenSilently,
        setListHistory,
        setVariant,
        setPageArr,
        setItem,
        setIndex
      );
    }
  };

  const handleLayout = (event) => {
    setVariant((draft) => {
      //get all the current buttons
      const buttons = JSON.parse(JSON.stringify(draft.list_details.buttons));

      //get max cells per page
      const maxCells = event.target.value.col * event.target.value.row;
      console.log("max cells", maxCells);

      //get amount of pages needed
      let pages = Math.ceil(draft.list_details.buttons.length / maxCells);
      console.log("orig pages", pages);
      // create empty button array
      let buttonArr = [];

      // for each page, push the page number, minimum button index and maximum button index to button array
      for (let index = 1; index <= pages; index++) {
        buttonArr.push({
          page: index,
          min: maxCells * (index - 1),

          max: maxCells * index - 1,
        });
      }
      //how many there should be
      const totalCells = buttonArr.at(-1).max;
      let maxNum = buttons.reduce((a, b) =>
        parseInt(a.id) < parseInt(b.id) ? b : a
      ).id;

      // if buttons less than total cells needed to fill all pages, push more buttons to array
      for (let i = buttons.length; i <= totalCells; i++) {
        const colour1 = data.colours[0].palette_details.colours.find(
          (col) => col.colour === "#000000"
        );
        maxNum = parseInt(maxNum) + 1;
        const colour2 = getTextColour(colour1.colour);
        buttons.push({
          id: maxNum.toString(),
          index: maxNum,
          style: {
            background: colour1.index,
            foreground: colour2.index,
            alignmentV: 1,
            alignmentH: 1,
            font: "10B",
          },
          text: "",
          mx: 1,
          my: 1,
          pageNo: 1,
          size: 1,
          functionType: 0,
          functionValue: 0,
          hideText: 0,
        });
      }

      buttons.map((x, index) => {
        const page = buttonArr?.find(
          (button) => index >= button.min && index <= button.max
        );
        x.pageNo = page?.page;
        x.mx = 1;
        x.my = 1;

        if (event.target.value.col > 8 || event.target.value.row > 8) {
          x.style.font = "8B";
        }
        return x;
      });
      // }

      const pagestodelete = [];

      // mapping over the button array, looking at the buttons for eaxh page, if all buttons on particular pae are 'empty', pushing that page in to page to delete array
      buttonArr.forEach((arr) => {
        if (
          arr.page !== 1 &&
          buttons
            .filter((button) => button.pageNo === arr.page)
            .every((button) => button.text === "" || button.text === "||") ===
            true
        ) {
          pagestodelete.push(arr.page);
        }
      });
      // filtering buttons where their page number is not in the page to delete array
      const newButtons = buttons.filter(
        (x) => !pagestodelete.includes(x.pageNo)
      );
      // creating a new page array for the
      let newPages = Math.ceil(newButtons.length / maxCells);

      let newButtonArr = [];

      for (let index = 1; index <= newPages; index++) {
        newButtonArr.push({
          page: index,
          min: maxCells * (index - 1),
          max: maxCells * index - 1,
        });
      }

      newButtons.map((x, index) => {
        const page = newButtonArr?.find(
          (button) => index >= button.min && index <= button.max
        );
        x.pageNo = page?.page;
        x.mx = 1;
        x.my = 1;

        if (event.target.value.col > 8 || event.target.value.row > 8) {
          x.style.font = "8B";
        }
        return x;
      });

      setPageArr(Array.from(Array(newPages), (e, i) => i + 1));
      draft.list_details.buttons = newButtons;
      draft.list_details.pages = newPages;
      draft.list_details.cols = event.target.value.col;
      draft.list_details.rows = event.target.value.row;

      setPage(1);
      setItem(newButtons[0]);
      setNewChanges(true);
    });
  };

  const handleSubmitLayout = async (type, newValue) => {
    setIsSaving(true);
    const newData = [...data[contextName]];
    var foundIndex = newData.findIndex(
      (x) => JSON.parse(x.uid) === JSON.parse(variant.uid)
    );

    const token = await getAccessTokenSilently();
    const newRowData = {
      updates: [variant],
    };

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    axios
      .post(API_ENDPOINTS.list, newRowData, config)
      .then(function (response) {
        const newList = response?.data?.list[0];
        newList.uid = newList.list_uid;
        newData[foundIndex] = newList;

        setData({ ...data, [contextName]: newData });

        setTimeout(() => {
          setIsSaving(false);
        }, 3000);
      })
      .catch(function (error) {
        console.log("res", error);
      });

    if (type === "list change") {
      handleListSelect2("null", newValue);
    }

    if (type === "variant change") {
      handleVariantSelect2("null", newValue);
    }

    if (type === "submit") {
      const options = newData.filter(
        (screen) =>
          screen.list_number === list.list_number && screen.list_isDeleted === 0
      );
      setVariantOptions(options);
    }

    setNewChanges(false);

    setErrorMessage({
      open: false,
      text: null,
      button1text: "",
      button1func: null,
      button2text: "",
      button2func: null,
    });

    blocker.proceed?.();
  };
  const handleDeletePage = () => {
    if (page > 1) {
      setVariant((draft) => {
        const maxCells = variant.list_details.cols * variant.list_details.rows;
        const newButtons = [...draft.list_details.buttons].filter(
          (button) => button.pageNo !== page
        );
        const newPages = Math.round(newButtons.length / maxCells);
        let buttonArr = [];

        for (let index = 1; index <= newPages; index++) {
          buttonArr.push({
            page: index,

            min: maxCells * (index - 1) - 1 < 0 ? 0 : maxCells * (index - 1),
            max: maxCells * index - 1,
          });
        }

        newButtons.map((x, index) => {
          const page = buttonArr?.find(
            (button) => index >= button.min && index <= button.max
          );
          x.pageNo = page?.page;
          return x;
        });

        draft.list_details.pages = parseInt(newPages);
        draft.list_details.buttons = newButtons;

        setPageArr(
          Array.from(Array(draft.list_details.pages), (e, i) => i + 1)
        );
      });

      setPage(page - 1);
    }
  };

  const handlePageUp = (direction) => {
    if (page === 1 && direction === "up") {
      return;
    }
    if (page === pageArr.length && direction === "down") {
      return;
    } else {
      setVariant((draft) => {
        const maxCells = draft.list_details.cols * draft.list_details.rows;
        const newButtons = [...draft.list_details.buttons];

        const swapElements = (array, index1, index2) => {
          [newButtons[index1], newButtons[index2]] = [
            newButtons[index2],
            newButtons[index1],
          ];
        };

        const newPages = Math.round(newButtons.length / maxCells);

        const startIndex = newButtons.findIndex(
          (button) => button.pageNo === page
        );

        for (let index = startIndex; index < startIndex + maxCells; index++) {
          swapElements(
            newButtons,
            index,
            direction === "up" ? index - maxCells : index + maxCells
          );
        }

        let buttonArr = [];
        for (let index = 1; index <= newPages; index++) {
          buttonArr.push({
            page: index,
            min:
              maxCells * (index - 1) - 1 < 0 ? 0 : maxCells * (index - 1) - 1,
            max: maxCells * index - 1,
          });
        }
        newButtons.map((x, index) => {
          const page = buttonArr?.find(
            (button) => index >= button.min && index <= button.max
          );

          x.pageNo = page?.page;
          return x;
        });

        draft.list_details.pages = parseInt(newPages);
        draft.list_details.buttons = newButtons;
        const newPageNo = direction === "up" ? page - 1 : page + 1;

        setPage(newPageNo);
        setNewChanges(true);
      });
    }
  };

  const handleNewPage = (event) => {
    if (event.target.value === "buttonClick") {
      setNewPage(true);
    } else {
      setPage(event.target.value);
    }
  };

  const closeDialog = () => {
    setErrorMessage({
      ...errorMessage,
      open: false,
    });
  };

  const [copyStyles, setCopyStyles] = React.useState(false);
  const [toggleHistory, handleToggleHistory] = React.useState(false);

  const [selectedItems, setSelectedItems] = React.useState([]);

  const [bulkBackground, setBulkBackground] = React.useState(
    data?.colours[0].palette_details.colours[36]
  );

  const [bulkForeground, setBulkForeground] = React.useState(
    data?.colours[0].palette_details.colours[63]
  );

  const handleBulkForeground = (colour) => {
    let foreground = data.colours[0].palette_details.colours.find(
      (col) => col.colour === colour
    );
    setBulkForeground(foreground);
  };

  const handleBulkBackground = (colour) => {
    let background = data.colours[0].palette_details.colours.find(
      (col) => col.colour === colour
    );
    setBulkBackground(background);
  };

  const [newItemModalOpen, setNewItemModalOpen] = React.useState(false);

  const value = {
    list,
    variant,
    setList,
    page,
    setPage,
    listArea,

    setListArea,
    setListOptions,
    newItemModalOpen,
    setNewItemModalOpen,
    setVariantOptions,
    setPageArr,
    bulkBackground,
    bulkForeground,
    setVariant,
    bottomLayout,
    setItem,
    openItem,
    handleSubmitLayout,
    handleRevertChanges,
    newChanges,
    setNewChanges,
    copyStyles,
    setCopyStyles,
    selectedItems,
    setSelectedItems,
    errorMessage,
    setErrorMessage,
    closeDialog,
  };

  const bottomValues = {
    bottomBarItems,
    setBottomBarItems,
    list,
    setList,
    listArea,
    setListArea,
    page,
    setPage,
    newChanges,
    setNewChanges,
  };

  const handleCopyFormat = () => {
    handleToggleHistory(false);
    setCopyStyles(!copyStyles);
  };

  const toggleHistoryClick = () => {
    setCopyStyles(false);
    handleToggleHistory(!toggleHistory);
  };
  const onSubmit = async (form) => {
    setIsSaving(true);

    let newList = {
      list_name: form.name,
      list_details: {},
    };

    newList.list_details.buttons = [];
    newList.list_details.cols = form.layout.col;
    newList.list_details.rows = form.layout.row;
    newList.list_details.selMin = form.selMin[0];
    newList.list_details.selMax = form.selMin[1];
    newList.list_details.staydown = form.staydown === true ? 1 : 0;
    newList.list_details.location = "L2";
    newList.list_variant = 0;

    autoFill(
      newList,
      form.autofilllist &&
        form.group?.items.filter(
          (item) =>
            item.plu_number.charAt(item.plu_number.length - 1) === "0" &&
            item.plu_isDeleted === 0
        ),
      data
    );

    const token = await getAccessTokenSilently();
    const newRowData = {
      updates: [newList],
    };
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    axios
      .post(API_ENDPOINTS.list, newRowData, config)
      .then(function (response) {
        console.log("res", response);

        newList = response.data.list[0];
        newList.uid = newList.list_uid;
        const lists = [...data[contextName], newList];
        setData({ ...data, [contextName]: lists });

        if (newList?.list_details?.location !== "F3") {
          const options = lists
            .filter(
              (list) =>
                list?.list_details?.location !== "F3" &&
                list?.list_details?.ignoreThisList !== true &&
                list?.list_variant === 0 &&
                list.list_isDeleted === 0
            )
            .sort(sortItems);

          setList(
            options.find(
              (list) =>
                list.list_number === newList.list_number &&
                list.list_isDeleted === 0
            )
          );
          setListOptions(options);
          const variantOptions = lists.filter(
            (screen) =>
              screen.list_number === newList.list_number &&
              screen.list_isDeleted === 0
          );

          setVariantOptions(variantOptions);

          setVariant(response.data.list[0]);

          setListArea(
            listAreas.find(
              (area) => area.tillName === newList?.list_details?.location
            )
          );
          setPage(1);

          setPageArr(
            Array.from(Array(newList.list_details.pages), (e, i) => i + 1)
          );
        }
        if (newList?.list_details?.location === "F3") {
          console.log("here 2");
          setList(newList);

          setPage(1);
          setBottomBarItems(
            newList.list_details.buttons.filter((button) => button.pageNo === 1)
          );
          setPageArr(
            Array.from(Array(newList.list_details.pages), (e, i) => i + 1)
          );
        }

        setTimeout(() => {
          setIsSaving(false);

          setModalVisible(!modalVisible);
        }, 2000);
      })
      .catch(function (error) {
        console.log("res", error);
      });
  };

  const proceedNav = () => {
    // console.log("here");
    setNewChanges(false);
    setErrorMessage({
      open: false,
      text: null,
      button1text: "",
      button1func: null,
      button2text: "",
      button2func: null,
    });
    setVariant();
    blocker.proceed?.();
    // blocker.reset?.();
    // console.log(blocker.state);
  };

  const handleNewVariant = () => {
    setOpenDropdown(false);
    setNewVariant(true);
  };

  React.useEffect(() => {
    if (blocker.state === "blocked" && !newChanges) {
      setVariant();

      blocker.reset();
    }
    if (blocker.state === "blocked") {
      setErrorMessage({
        open: true,
        text: `You have unfinished changes to list '${list.list_name}'. Please save or discard any changes before continuing.`,
        button1text: "Discard Changes",
        button1func: proceedNav,
        button2text: "Save Changes",
        button2func: handleSubmitLayout,
      });
    }
  }, [blocker, newChanges]);

  const makeCurrent = async () => {
    const token = await getAccessTokenSilently();

    const originalCurrentObj = listHistory.find(
      (i) => i[`list_isCurrent`] === 1
    );

    const curr = listHistory.find((i) => i.uid === variant.uid);
    const newCurrentObj = { ...curr };

    newCurrentObj[`list_isCurrent`] = 1;
    newCurrentObj[`list_isDeleted`] = 0;

    const newRowData = {
      updates: [newCurrentObj],
    };
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    // let postStatus;
    axios
      .post(API_ENDPOINTS["list"], newRowData, config)
      .then(function (response) {
        // postStatus = response.status;
        if (response.status === 200) {
          // let updatedData;
          // if (isNew === true) {
          const updatedRow = response?.data["list"][0];
          updatedRow.uid = response?.data["list"][0][`list_uid`];
          const newData = [...data.screens];

          const indexToReplace = newData.findIndex(
            (row) => row.uid === originalCurrentObj.uid
          );

          newData[indexToReplace] = updatedRow;
          setVariantOptions(
            newData.filter(
              (screen) =>
                screen.list_number === updatedRow.list_number &&
                screen.list_isDeleted === 0
            )
          );
          setVariant(updatedRow);
          const updatedData = {
            ...data,
            [contextName]: [...newData],
          };

          if (updatedRow.list_variant === 0) {
            setListOptions(
              newData
                .filter(
                  (list) =>
                    // list?.list_details?.location !== "F3" &&
                    list?.list_details?.ignoreThisList !== true &&
                    list?.list_variant === 0 &&
                    list?.list_isDeleted === 0
                )
                .sort(sortItems)
            );

            setList(updatedRow);
          }

          getHistory(
            updatedRow,
            getAccessTokenSilently,
            setListHistory,
            setVariant,
            setPageArr,
            setItem,
            setIndex
          );
          setData(updatedData);
          // setSnackbar({
          // 	children: "successfully saved",
          // 	severity: "success",
          // });
        } else {
          // setSnackbar({
          // 	children: "Error, couldn't save data",
          // 	severity: "error",
          // });
        }
      })
      .catch(function (error) {
        console.log(error);
        // postStatus = error.response.status;
        // setSnackbar({
        // 	children: error?.response?.data?.error
        // 		? error?.response?.data?.error + " - couldn't save data"
        // 		: "Error - couldn't save data",
        // 	severity: "error",
        // });
      });
  };
  const toolbarProps = {
    openAdvancedSettings,
    setDeleteErrorMessage,
    isSaving,
    handleListSelect,
    handleRevertChanges,
    closeDialog,
    list,
    listOptions,
    handleBulkBackground,
    handleBulkForeground,
    handleCopyFormat,
    handleDeletePage,
    handleLayout,
    setNewPage,
    setNewVariant,
    copyStyles,
    setErrorMessage,
    handleNewPage,
    variant,
    page,
    toggleHistory,
    bulkBackground,
    bulkForeground,
    makeCurrent,
    toggleHistoryClick,
    handleNext,
    pageArr,
    handleSubmitLayout,
    setModalVisible,
    handleVariantSelect,
    handleNewVariant,
    openDropDown,
    setOpenDropdown,
    variantOptions,
    newVariant,
    handlePageUp,
    index,
    listHistory,
    newPage,
    data,
    handlePrev,
    contextName,

    handleListSelect2,
    handleVariantSelect2,
    setList,
    setVariant,
    setPageArr,
    setPage,

    setNewChanges,
  };

  return (
    <>
      {loading || data[contextName] === null ? (
        <Spinner />
      ) : (
        <GridContext.Provider value={value}>
          <FunctionBarContext.Provider value={bottomValues}>
            <CursorContextProvider>
              <ErrorDialog
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                // discardChanges={handleRevertChanges}
                // saveChanges={handleSubmitLayout}
                // onClose={closeDialog}
                // variantOptions={variantOptions}
                // variant={variant}
                // setNewMain={setNewMain}
                // newMain={newMain}
              />
              <ListDeleteDialog
                deleteErrorMessage={deleteErrorMessage}
                setDeleteErrorMessage={setDeleteErrorMessage}
                // discardChanges={handleRevertChanges}
                // saveChanges={handleSubmitLayout}
                isSaving={isSaving}
                setIsSaving={setIsSaving}
                onClose={closeDialog}
                variantOptions={variantOptions}
                // variant={variant}
                // setNewMain={setNewMain}
                // newMain={newMain}
              />
              <NewListModal
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                onSubmit={onSubmit}
                isSaving={isSaving}
              />
              <NewPageDialog
                open={newPage}
                setOpen={setNewPage}
                page={page}
                setPage={setPage}
              />
              <ListVariantForm
                list={list}
                setModalVisible={setNewVariant}
                modalVisible={newVariant}
                setOpenDropdown={setOpenDropdown}
                contextName={contextName}
              />

              <NewItemModal
                setNewItemModalOpen={setNewItemModalOpen}
                newItemModalOpen={newItemModalOpen}
              />
              <AdvancedSettings
                modalVisible={advancedSettings}
                setModalVisible={openAdvancedSettings}
                newChanges={newChanges}
                setNewChanges={setNewChanges}
                variant={variant}
                setVariant={setVariant}
                contextName={contextName}
                variantOpts={variantOptions}
              />
              <Box
                sx={{
                  flex: 1,
                  maxHeight: "100%",

                  width: "100%",
                  ml: 4,
                  mr: 4,
                  pt: 1,
                }}
              >
                <DesignerToolbar {...toolbarProps} />

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flex: 1,
                    minHeight: "80%",
                  }}
                >
                  <Box
                    sx={{
                      width: "85%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flex: 1,
                      minHeight: "100%",
                      mb: 4,
                    }}
                  >
                    <motion.div
                      transition={{
                        layout: { duration: 0.3 },
                      }}
                      layout
                      data-isopen={!editBar}
                      initial={{ width: "100%", height: "100%" }}
                      style={{ display: "flex", height: "100%" }}
                    >
                      <MainGrid
                        openItem={openItem}
                        setItem={setItem}
                        editBar={editBar}
                        openEditBar={openEditBar}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                      />
                    </motion.div>
                  </Box>
                  {editBar && (
                    <Box
                      sx={{
                        width: "15%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        minHeight: "100%",
                        mb: 4,
                        ml: 4,
                      }}
                    >
                      <motion.div
                        // transition={spring}
                        initial={{ x: 300, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 300, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        layout
                        data-isopen={editBar}
                        style={{
                          display: "flex",
                          flex: 1,
                          height: "100%",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: "100%",
                        }}
                      >
                        <EditSide
                          openItem={openItem}
                          setItem={setItem}
                          editBar={editBar}
                          openEditBar={openEditBar}
                          handleSubmitLayout={handleSubmitLayout}
                          handleCloseEditBar={handleCloseEditBar}
                        />
                      </motion.div>
                    </Box>
                  )}{" "}
                </Box>
              </Box>
            </CursorContextProvider>
          </FunctionBarContext.Provider>
        </GridContext.Provider>
      )}
    </>
  );
}
